import { FireBaseService } from "../../firebase/firebase";
import {
  CHANGE_ACCESS_LIMITED_MODAL_VISIBILITY_STATUS,
  DomainAccessModalActionTypes,
  DomainAccessModalDataState,
  HIDE_DOMAIN_ACCESS_MODAL,
  SET_MODAL_DATA
} from "./types";

export const showDomainAccessRequiredModal = (accessName: string | string[]): DomainAccessModalActionTypes => {
  const firebase = new FireBaseService();
  firebase.logEvent("licence_restriction", {
    access_name: accessName
  });
  return {
    type: SET_MODAL_DATA,
    meta: {
      params: {
        isDomainAccessModalOpen: true,
        accessName
      } as DomainAccessModalDataState
    }
  };
};

export const hideDomainAccessModal = (): DomainAccessModalActionTypes => {
  return {
    type: HIDE_DOMAIN_ACCESS_MODAL
  };
};

export const changeAccessLimitedModalVisibilityStatus = (
  showAccessLimitedModal: boolean = false
): DomainAccessModalActionTypes => {
  return {
    type: CHANGE_ACCESS_LIMITED_MODAL_VISIBILITY_STATUS,
    meta: {
      params: {
        showAccessLimitedModal
      }
    }
  };
};

export type SetModalDataAction = typeof showDomainAccessRequiredModal | typeof hideDomainAccessModal;
